const auth = (state) => state.auth;

export default auth;
